import * as actions from "./CreateAccount/CreateAccount/actions.js";
import * as actions$1 from "./Login/Login/actions.js";
import * as actions$2 from "./Logout/Logout/actions.js";
import * as actions$3 from "./OptIns/OptIns/actions.js";
import * as actions$4 from "./ResetPassword/ResetPassword/actions.js";
import * as actions$5 from "./UserData/UserData/actions.js";
const INIT = "auth/init";
const GOTO = "auth/goto";
const init = (payload) => ({
  type: INIT,
  payload
});
const goto = (payload) => ({
  type: GOTO,
  payload
});
export {
  actions as CreateAccountActions,
  GOTO,
  INIT,
  actions$1 as LoginActions,
  actions$2 as LogoutActions,
  actions$3 as OptInsActions,
  actions$4 as ResetPasswordActions,
  actions$5 as UserDataActions,
  goto,
  init
};
//# sourceMappingURL=actions.js.map
